var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_5122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 7.33354C2.86878 6.04737 3.50034 4.86672 4.47665 4.01262C5.45295 3.15852 6.70707 2.6895 8.00424 2.69338C9.30141 2.69726 10.5527 3.17376 11.5239 4.03369C12.4951 4.89362 13.1195 6.07802 13.2804 7.36517C13.4413 8.65233 13.1276 9.95401 12.398 11.0265C11.6684 12.0991 10.5729 12.8689 9.31656 13.192C8.06026 13.515 6.72928 13.3692 5.57278 12.7817C4.41627 12.1942 3.51353 11.2053 3.03353 10.0002M2.7002 13.3335V10.0002H6.03353",
    stroke: "#32374E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_5122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignResume);
export default __webpack_public_path__ + "static/media/campaign-resume.f065d773.svg";
export { ForwardRef as ReactComponent };